import ImageIcon from "../../assets/icons/image-icon.svg";
import PlayVideoIcon from "../../assets/icons/play-video-icon.svg";
import InfoIcon from "../../assets/icons/alert-circle-icon.svg";
import React, {useState} from "react";
import PropTypes from 'prop-types';
import {RemarksModal} from "./index";

function RemarkDetail(props) {
  const {rowData} = props;
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const handleClick = () => {
    setOpenModal(true);
    setModalData(rowData);
  };

  const content = [];
  if (rowData.remark_video) {
    content.push(
      <div key="remark_video" className="bg-[#D1FADF] hover:[#D1FADF] w-[32px] h-[32px] p-2 rounded-[16px] cursor-pointer mr-2">
        <img src={PlayVideoIcon} className="w-[16px] h-[16px]" onClick={handleClick} alt="icon-video"/>
      </div>
    );
  }
  if (rowData.remark_image) {
    content.push(
      <div key="remark_image" className="bg-[#D1E9FF] hover:[#D1E9FF] w-[32px] h-[32px] p-2 rounded-[16px] cursor-pointer mr-2">
        <img src={ImageIcon} className="w-[16px] h-[16px]" onClick={handleClick} alt="icon-remark"/>
      </div>
    );
  }
  if (rowData.remark_text) {
    content.push(
      <div key="remark_text" className="bg-[#FEF0C7] hover:[#FEF0C7] w-[32px] h-[32px] p-2 rounded-[16px] cursor-pointer">
        <img src={InfoIcon} className="w-[16px] h-[16px]" onClick={handleClick} alt="icon-info"/>
      </div>
    );
  }
  if (content.length > 0) {
    return (
      <>
        <div className="flex">{content}</div>
        <RemarksModal openModal={openModal}
                      setOpenModal={setOpenModal}
                      modalData={modalData} />
      </>
    );
  }
  return <span className="px-3">-</span>;
}

RemarkDetail.propTypes = {
  rowData: PropTypes.object.isRequired,
};

export default RemarkDetail;
